export const SET_VISIT_COOKIE = '/authorization/header/add'
